jQuery_T4NT(document).ready(function($) {
  console.log("custom.js: Документ готов (jQuery_T4NT.ready)");

  // Список брендов, которые нужно удалять, если они идут в начале текста опции.
  // Добавляйте сюда другие бренды, если они появляются в начале и их нужно убрать.
  const brandsToRemoveAtStart = ['fossil', 'amazfit', 'samsung', 'apple', 'garmin', 'google', 'xiaomi', 'huawei', 'honor', 'moto', 'nokia', 'oneplus', 'pebble', 'realme', 'ticwatch', 'withings', 'yamay', 'hero', 'huami', 'imilab'];
  // Используйте только строчные буквы для сравнения.

  // Функция для форматирования текста опции (удаление бренда)
  function removeBrandFromOptionText(selectElement) {
    console.log("custom.js: Вызвана removeBrandFromOptionText.");
    if (!selectElement) {
      console.warn('custom.js: Целевой элемент select не найден: dropdown-field_2 (в функции).');
      return;
    }
    console.log("custom.js: Элемент select найден:", selectElement);

    Array.from(selectElement.options).forEach((option, index) => {
      // Проверяем, была ли опция уже обработана
      if (option.dataset.processed === 'true') {
        return; // Пропускаем уже обработанные опции
      }

      const originalText = option.textContent.trim(); // Удаляем пробелы по краям
      console.log(`custom.js: Опция ${index} - Исходный текст: "${originalText}", Value: "${option.value}"`);

      // Пропускаем опции, которые:
      // 1. Имеют значение "-1" (как "Select Model/Type")
      // 2. Или пустые
      // 3. Или состоят из одного слова (обычно это означает, что бренда нет или он уже убран)
      if (option.value === "-1" || originalText === '' || !originalText.includes(' ')) {
        console.log(`custom.js: Пропущена опция ${index} (выбор, пустая или одно слово).`);
        option.dataset.processed = 'true'; // Всегда помечаем как обработанную
        return;
      }

      let modifiedText = originalText;
      const parts = originalText.split(' ');
      const firstWord = parts[0].toLowerCase(); // Первое слово в нижнем регистре
      const lastWord = parts[parts.length - 1].toLowerCase(); // Последнее слово в нижнем регистре

      // Правило 1: Удалить "Apple", если это последнее слово
      // И убедиться, что есть хотя бы два слова для обработки (например, "Hand Apple")
      if (parts.length > 1 && lastWord === 'apple') {
        modifiedText = parts.slice(0, -1).join(' '); // Удаляем последнее слово
        console.log(`custom.js: Опция ${index} - Обнаружен "Apple" в конце. Новый текст: "${modifiedText}"`);
      }
      // Правило 2: Если правило 1 не сработало, и первое слово - это известный бренд из списка
      else if (parts.length > 1 && brandsToRemoveAtStart.includes(firstWord)) {
        modifiedText = parts.slice(1).join(' '); // Удаляем первое слово
        console.log(`custom.js: Опция ${index} - Удалено первое слово (бренд "${firstWord}"). Новый текст: "${modifiedText}"`);
      } else {
        console.log(`custom.js: Опция ${index} - Недостаточно слов или не соответствует правилам удаления.`);
      }

      // Обновляем textContent только если текст действительно изменился
      if (originalText !== modifiedText) {
        option.textContent = modifiedText; // Обновляем отображаемый текст
        console.log(`custom.js: Опция ${index} - Изменено: "${originalText}" -> "${modifiedText}"`);
      } else {
        console.log(`custom.js: Опция ${index} - Текст уже в конечном формате или не требует изменений.`);
      }
      option.dataset.processed = 'true'; // Помечаем как обработанную после попытки обработки
    });
    console.log("custom.js: removeBrandFromOptionText завершена.");
  }

  // --- Остальная часть скрипта (MutationObserver и variant:changed) без изменений ---
  const targetNode = document.body;
  const config = { childList: true, subtree: true };

  const observerForSelect = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
              const modelSelect = document.getElementById('dropdown-field_2');
              if (modelSelect) {
                  console.log('custom.js: MutationObserver: dropdown-field_2 обнаружен в DOM!');
                  removeBrandFromOptionText(modelSelect);

                  const optionsObserver = new MutationObserver((optsMutationsList) => {
                      for (const optMutation of optsMutationsList) {
                          if (optMutation.type === 'childList' && optMutation.addedNodes.length > 0) {
                              console.log('custom.js: MutationObserver на select: Обнаружены новые опции.');
                              setTimeout(() => {
                                  removeBrandFromOptionText(modelSelect);
                              }, 10);
                          }
                      }
                  });
                  optionsObserver.observe(modelSelect, { childList: true });
                  console.log('custom.js: MutationObserver запущен на dropdown-field_2 для опций.');
              }
          }
      }
  });

  observerForSelect.observe(targetNode, config);
  console.log('custom.js: MutationObserver запущен для отслеживания dropdown-field_2.');

  $(document).on("variant:changed", function(evt) {
    console.log("custom.js: Событие 'variant:changed' сработало.");
    const modelSelect = document.getElementById('dropdown-field_2');

    if (modelSelect) {
        setTimeout(() => {
          console.log("custom.js: Задержка после 'variant:changed' завершена. Запуск форматирования.");
          Array.from(modelSelect.options).forEach(option => {
              delete option.dataset.processed;
          });
          removeBrandFromOptionText(modelSelect);
        }, 50);
    } else {
        console.warn("custom.js: dropdown-field_2 не найден при срабатывании variant:changed.");
    }
  });
});